module.exports = __webpack_public_path__ + "static/media/boxing-bell.cea0f308.wav";